<template>
  <el-dialog width="800px" v-if="isShowDevice" class="dialog-code" v-bind="$attrs" :close-on-click-modal="false" :before-close="handleClose">
    <span slot="title" class="dialog-title">录入设备信息</span>
    <div v-loading="dialogLoading" class="dialog-wrap">
      <div class="dialog-item-wrap">
        <el-form ref="form" :model="form" label-width="167px" label-position="left">
          <!-- <el-form-item prop="deviceUnit" :rules="[{ required: true, message: '自定义标识不能为空', trigger: ['blur', 'change'] }]"> -->
          <el-form-item>
            <template slot="label">
              自定义设备标识
              <el-tooltip effect="dark" placement="top" :offset="-170">
                <span slot="content" class="custom-tip">
                  用户自定义的用于标识一台设备的字符串。您可以使用设备型号、IP地址、设备所处地理位置等信息的组合作为自定义设备标识。此标识仅在本次申请中有效，对历史或后续操作不影响。
                </span>
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            <el-autocomplete
              style="width: 100%"
              v-model="form.deviceUnit"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              :maxlength="40"
              value-key="deviceUnit"
              @select="handleDeviceSelect"
            ></el-autocomplete>
          </el-form-item>
          <!-- 授权码绑定模式 -->
          <template v-if="deviceData.isExtendMode_Radio">
            <el-form-item
              label="请选择绑定模式"
              prop="extendMode_Radio"
              :rules="[{ required: true, message: '绑定模式不能为空', trigger: ['blur', 'change'] }]"
            >
              <el-select v-model="form.extendMode_Radio" style="width: 100%" @change="handleCodeModelChange">
                <el-option label="仅绑定当前授权码" :value="0" v-if="deviceData.extendMode_Radio_DeviceInfo === 'true'"></el-option>
                <el-option label="绑定当前授权码+历史激活文件" :value="1" v-if="deviceData.extendMode_Radio_HistoryFile === 'true'"></el-option>
                <el-option label="绑定当前授权码+服务器主机文件" :value="2" v-if="deviceData.extendMode_Radio_HostInfo === 'true'"></el-option>
              </el-select>
            </el-form-item>
            <!-- 设备信息文件 -->
            <el-form-item
              label="最新历史激活文件"
              prop="oldActivationFileName"
              :rules="[{ required: true, message: '最新历史激活文件不能为空', trigger: ['blur', 'change'] }]"
              v-if="form.extendMode_Radio === 1"
            >
              <template slot="label">
                最新历史激活文件
                <el-tooltip effect="dark" placement="top" :offset="-170">
                  <span slot="content" class="custom-tip">
                    用户自定义的用于标识一台设备的字符串。您可以使用设备型号、IP地址、设备所处地理位置等信息的组合作为自定义设备标识。此标识仅在本次申请中有效，对历史或后续操作不影响。
                  </span>
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </template>
              <device-old-upload-file
                :uploadType="'old'"
                :isMaster="true"
                :isBatch="isBatch"
                :index="0"
                :licenseKeys="licenseKeys"
                :deviceUnit="form.deviceUnit"
                v-model="form.oldActivationFileName"
                @uploadCallback="uploadOldCallBackFn"
                @fileClearCallback="oldDeviceFileClearFn"
              />
            </el-form-item>
            <!-- <el-form-item v-if="form.extendMode_Radio === 2">
              <template slot="label">
                服务器主机文件
                <el-tooltip effect="dark" placement="top" :offset="-250">
                  <span slot="content" class="custom-tip">
                    您在设备Web页面生成“服务器主机文件”时，可以指定文件中需要包含的授权码。所以，该文件中可以同时包含授权码和设备信息。上传“服务器主机文件”后，紫光云
                    License激活平台会自动联想该文件包含的授权信息以及设备信息，您可以将当前操作的授权码、指定的授权码和该设备绑定
                  </span>
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </template>
              <device-upload-file :isMaster="true" :isBatch="isBatch" v-model="form.oldActivationFileName" />
            </el-form-item> -->
          </template>
          <!-- 可拆分，总数 -->
          <el-form-item v-if="deviceData.isCanSplit">
            <template slot="label">
              可用总数/总数
              <el-tooltip effect="dark" placement="top" :offset="-170">
                <span slot="content" class="custom-tip"> 当前授权码中包含的可用授权数量/当前授权码中包含的授权总数 </span>
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            {{ deviceData.surplusQuantity }} / {{ deviceData.totelQuantity }}
          </el-form-item>
          <!--  DID码，文件，根据配置进行显示 -->
          <el-form-item
            :label="deviceData.didLabl"
            v-if="!deviceData.isConfirm && !dialogLoading"
            :error="form.lstInfos[0].deviceFileErr"
            :prop="form.didType === 'code' ? `lstInfos.0.did` : `lstInfos.0.deviceOtherInfoFileName`"
            :rules="{ required: true, message: `${form.didType === 'code' ? '请输入DID码' : '请上传DID文件'}`, trigger: ['blur', 'change'] }"
          >
            <template slot="label">
              <span v-if="deviceData.isShowDID === true && deviceData.isShowDeviceOtherInfoFile === true"> DID: </span>
              <span v-if="deviceData.isShowDID === true && deviceData.isShowDeviceOtherInfoFile === false">DID码：</span>
              <span v-if="deviceData.isShowDID === false && deviceData.isShowDeviceOtherInfoFile === true">DID文件：</span>
              <el-tooltip effect="dark" placement="top" :offset="-170">
                <span slot="content" class="custom-tip"
                  >对于支持display license device-id命令的设备，请在设备上执行该命令来获取相关的设备信息。对于不支持display license
                  device-id命令的设备，请参考对应产品的License使用指南来获取相关的设备信息。</span
                >
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            <template v-if="deviceData.isShowDID === true && deviceData.isShowDeviceOtherInfoFile === true">
              <el-radio-group v-model="form.didType" @change="handleDidTypeChange">
                <el-radio label="code">码</el-radio>
                <el-radio label="file">文件</el-radio>
              </el-radio-group>
              <el-input class="mt10" key="didCode" v-show="form.didType === 'code'" v-model="form.lstInfos[0].did"></el-input>
              <div v-show="form.didType === 'file'" class="mt10">
                <!-- 文件上传 -->
                <device-upload-file
                  v-model="form.lstInfos[0].deviceOtherInfoFileName"
                  :index="0"
                  :isBatch="isBatch"
                  :isMaster="true"
                  :licenseKeys="licenseKeys"
                  :deviceUnit="form.deviceUnit"
                  @uploadCallback="uploadCallbackFn"
                  @fileClearCallback="deviceFileClearFn"
                />
              </div>
            </template>
            <template v-if="deviceData.isShowDID === true && deviceData.isShowDeviceOtherInfoFile === false">
              <el-input class="mt10" key="didCode" v-show="form.didType === 'code'" v-model="form.lstInfos[0].did"></el-input>
            </template>
            <template v-if="deviceData.isShowDID === false && deviceData.isShowDeviceOtherInfoFile === true">
              <!-- 文件上传 -->
              <device-upload-file
                v-model="form.lstInfos[0].deviceOtherInfoFileName"
                :index="0"
                :isBatch="isBatch"
                :isMaster="true"
                :licenseKeys="licenseKeys"
                :deviceUnit="form.deviceUnit"
                @uploadCallback="uploadCallbackFn"
                @fileClearCallback="deviceFileClearFn"
              />
            </template>
          </el-form-item>

          <!-- 产品分类 -->
          <el-form-item
            v-if="deviceData.isProductCategory"
            key="category"
            label="产品分类"
            prop="productCategoryID"
            :rules="{
              required: true,
              message: '请选择产品分类',
              trigger: 'change',
            }"
          >
            <el-select v-model="form.productCategoryID" style="width: 100%">
              <el-option v-for="item in productCategoryList" :key="item.value" :value="item.value" :label="item.text"></el-option>
            </el-select>
          </el-form-item>

          <!-- 设备信息文件支持拆分 -->
          <template>
            <div :class="{ 'form-item-wrap': isShowSplit }" v-for="(v, i) in form.lstInfos" :key="i">
              <div :class="{ 'split-padding split-bottom-line': isShowSplit }">
                <h4 class="split-item-title" v-if="isShowSplit">设备{{ i + 1 }}</h4>
                <!-- 双机热备 -->
                <el-form-item key="backupType" v-if="deviceData.isDeviceBackupType" label="请选择双机备份类型" style="margin-bottom: 8px">
                  <el-radio-group v-model="v.deviceBackupType" @change="handleDeviceRadioChange(v)">
                    <el-radio :label="v.value" v-for="v in backupTypes" :key="v.value">{{ v.label }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- 服务器合同号 -->
                <el-form-item
                  key="contractFormItem"
                  class="contract-item"
                  v-if="deviceData.isContractSN && v.deviceBackupType === '2'"
                  :label="'服务/产品合同号'"
                  :prop="`lstInfos.${i}.contractSN`"
                  :rules="[
                    {
                      required: true,
                      message: '不能为空',
                      trigger: ['blur', 'change'],
                    },
                    {
                      type: 'string',
                      pattern: /^[\s\S]{0,19}$/,
                      message: '请按正确格式填写',
                      trigger: ['blur', 'change'],
                    },
                  ]"
                >
                  <div style="display: flex">
                    <el-input style="flex: 1" key="ContractSN" v-model="v.contractSN" :maxlength="20" :readonly="isContractSnReadonly"></el-input>
                    <el-checkbox
                      style="margin: 0 8px 0 14px"
                      v-model="v.tempHotActivation"
                      @change="handleDoubleCheckChange(v)"
                      :checked="v.tempHotActivation"
                    ></el-checkbox>
                    <span>申请临时双机热备激活码</span>
                  </div>
                </el-form-item>
              </div>
              <div :class="{ 'split-padding': isShowSplit }">
                <!-- 主设备 -->
                <div>
                  <h4 class="split-item-title" v-if="deviceData.isDeviceBackupType && v.deviceBackupType !== '0'">主设备</h4>
                  <!-- 设备唯一码 -->
                  <el-form-item
                    key="did"
                    v-if="deviceData.isDID"
                    :label="deviceData.didLabl"
                    :prop="`lstInfos.${i}.did`"
                    :rules="{
                      required: true,
                      message: `请输入${deviceData.didLabl}`,
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <el-input v-model="v.did"></el-input>
                  </el-form-item>
                  <!-- 设备信息文件 -->
                  <el-form-item
                    label="设备信息文件"
                    v-show="deviceData.isDeviceOtherInfoFile"
                    :error="v.deviceFileErr"
                    :rules="
                      deviceData.isDeviceOtherInfoFile
                        ? {
                            required: true,
                            message: '请上传设备信息文件',
                            trigger: ['blur', 'change'],
                          }
                        : {}
                    "
                    :prop="`lstInfos.${i}.deviceOtherInfoFileName`"
                  >
                    <!-- 文件上传 -->
                    <device-upload-file
                      key="uploadActivationFile"
                      v-model="v.deviceOtherInfoFileName"
                      :index="i"
                      :isBatch="isBatch"
                      :isMaster="true"
                      :licenseKeys="licenseKeys"
                      :deviceUnit="form.deviceUnit"
                      @uploadCallback="uploadCallbackFn"
                      @fileClearCallback="deviceFileClearFn"
                    />
                  </el-form-item>
                  <!-- H3C设备SN -->
                  <el-form-item
                    key="H3CDeviceSN"
                    v-if="deviceData.isH3CDeviceSN"
                    :label="'设备SN'"
                    :prop="`lstInfos.${i}.h3CDeviceSN`"
                    :rules="h3cSNRule"
                  >
                    <el-input v-model="v.h3CDeviceSN" :maxlength="100"></el-input>
                  </el-form-item>
                  <!-- 主设备扩展字段1 -->
                  <el-form-item
                    key="DeviceExtendInfoKey1"
                    v-if="deviceData.isDeviceExtendInfoKey1"
                    :label="deviceData.deviceExtendInfoKey1Labl"
                    :prop="`lstInfos.${i}.deviceExtendInfoKey1`"
                    :rules="{
                      required: true,
                      message: `${deviceData.deviceExtendInfoKey1Labl}不能为空`,
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <el-input v-model="v.deviceExtendInfoKey1"></el-input>
                  </el-form-item>
                  <!-- 主设备扩展字段2 -->
                  <el-form-item
                    key="DeviceExtendInfoKey2"
                    v-if="deviceData.isDeviceExtendInfoKey2"
                    :label="deviceData.deviceExtendInfoKey2Labl"
                    :prop="`lstInfos.${i}.deviceExtendInfoKey2`"
                    :rules="{
                      required: true,
                      message: `${deviceData.deviceExtendInfoKey2Labl}不能为空`,
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <el-input v-model="v.deviceExtendInfoKey2"></el-input>
                  </el-form-item>
                  <!-- 主设备扩展字段3 -->
                  <el-form-item
                    key="DeviceExtendInfoKey3"
                    v-if="deviceData.isDeviceExtendInfoKey3"
                    :label="deviceData.deviceExtendInfoKey3Labl"
                    :prop="`lstInfos.${i}.deviceExtendInfoKey3`"
                    :rules="{
                      required: true,
                      message: `${deviceData.deviceExtendInfoKey3Labl}不能为空`,
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <el-input v-model="v.deviceExtendInfoKey3"></el-input>
                  </el-form-item>
                  <!-- 主设备扩展字段4 -->
                  <el-form-item
                    key="DeviceExtendInfoKey4"
                    v-if="deviceData.isDeviceExtendInfoKey4"
                    :label="deviceData.deviceExtendInfoKey4Labl"
                    :prop="`lstInfos.${i}.deviceExtendInfoKey4`"
                    :rules="{
                      required: true,
                      message: `${deviceData.deviceExtendInfoKey4Labl}不能为空`,
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <el-input v-model="v.deviceExtendInfoKey4"></el-input>
                  </el-form-item>
                  <!-- 主设备扩展字段5 -->
                  <el-form-item
                    key="DeviceExtendInfoKey5"
                    v-if="deviceData.isDeviceExtendInfoKey5"
                    :label="deviceData.deviceExtendInfoKey5Labl"
                    :prop="`lstInfos.${i}.deviceExtendInfoKey5`"
                    :rules="{
                      required: true,
                      message: `${deviceData.deviceExtendInfoKey5Labl}不能为空`,
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <el-input v-model="v.deviceExtendInfoKey5"></el-input>
                  </el-form-item>
                </div>
                <div :class="{ 'split-lint mb14': isShowSplit }" v-if="deviceData.isDeviceBackupType && v.deviceBackupType !== '0'"></div>
                <!-- 备份设备 -->
                <div v-if="deviceData.isDeviceBackupType && v.deviceBackupType !== '0'">
                  <h4 class="split-item-title mt14">备份设备</h4>
                  <!-- 设备唯一码 -->
                  <el-form-item
                    key="backupDid"
                    v-if="deviceData.isDID"
                    :label="deviceData.didLabl"
                    :prop="`lstInfos.${i}.spareDID`"
                    :rules="{
                      required: true,
                      message: `${deviceData.didLabl}`,
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <el-input v-model="v.spareDID"></el-input>
                  </el-form-item>
                  <!-- 设备信息文件 -->
                  <el-form-item
                    key="backupDeviceFile"
                    v-show="deviceData.isDeviceBackupType && v.deviceBackupType !== '0' && deviceData.isDeviceOtherInfoFile"
                    label="设备信息文件"
                    :error="v.spareDeviceFileErr"
                    :prop="`lstInfos.${i}.spareDeviceOtherInfoFileName`"
                    :rules="
                      deviceData.isDeviceBackupType && v.deviceBackupType !== '0' && deviceData.isDeviceOtherInfoFile
                        ? {
                            required: true,
                            message: '请上传设备信息文件',
                            trigger: ['blur', 'change'],
                          }
                        : {}
                    "
                  >
                    <device-upload-file
                      key="spareDeviceOtherInfoFileName"
                      v-model="v.spareDeviceOtherInfoFileName"
                      :index="i"
                      :isMaster="false"
                      :isBatch="isBatch"
                      :licenseKeys="licenseKeys"
                      :deviceUnit="form.deviceUnit"
                      @uploadCallback="spareUploadCallbackFn"
                      @fileClearCallback="deviceFileClearFn"
                    />
                  </el-form-item>
                  <template v-if="deviceData.isDeviceBackupType && v.deviceBackupType !== '0'">
                    <!-- 备份H3C设备SN -->
                    <el-form-item
                      v-if="deviceData.isH3CDeviceSN"
                      key="spareH3CDeviceSN"
                      :label="'设备SN'"
                      :prop="`lstInfos.${i}.spareH3CDeviceSN`"
                      :rules="h3cSNRule"
                    >
                      <el-input v-model="v.spareH3CDeviceSN" :maxlength="100"></el-input>
                    </el-form-item>
                    <!-- 备份设备扩展1 -->
                    <el-form-item
                      key="backupDeviceExtendInfoKey1"
                      v-if="deviceData.isDeviceExtendInfoKey1"
                      :label="deviceData.deviceExtendInfoKey1Labl"
                      :prop="`lstInfos.${i}.spareDeviceExtendInfoKey1`"
                      :rules="{
                        required: true,
                        message: `${deviceData.deviceExtendInfoKey1Labl}不能为空`,
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-input v-model="v.spareDeviceExtendInfoKey1"></el-input>
                    </el-form-item>
                    <!-- 备份设备扩展2 -->
                    <el-form-item
                      key="backupDeviceExtendInfoKey2"
                      v-if="deviceData.isDeviceExtendInfoKey2"
                      :label="deviceData.deviceExtendInfoKey2Labl"
                      :prop="`lstInfos.${i}.spareDeviceExtendInfoKey2`"
                      :rules="{
                        required: true,
                        message: `${deviceData.deviceExtendInfoKey2Labl}不能为空`,
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-input v-model="v.spareDeviceExtendInfoKey2"></el-input>
                    </el-form-item>
                    <!-- 备份设备扩展3 -->
                    <el-form-item
                      key="backupDeviceExtendInfoKey3"
                      v-if="deviceData.isDeviceExtendInfoKey3"
                      :label="deviceData.deviceExtendInfoKey3Labl"
                      :prop="`lstInfos.${i}.spareDeviceExtendInfoKey3`"
                      :rules="{
                        required: true,
                        message: `${deviceData.deviceExtendInfoKey3Labl}不能为空`,
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-input v-model="v.spareDeviceExtendInfoKey3"></el-input>
                    </el-form-item>
                    <!-- 备份设备扩展4 -->
                    <el-form-item
                      key="backupDeviceExtendInfoKey4"
                      v-if="deviceData.isDeviceExtendInfoKey4"
                      :label="deviceData.deviceExtendInfoKey4Labl"
                      :prop="`lstInfos.${i}.spareDeviceExtendInfoKey4`"
                      :rules="{
                        required: true,
                        message: `${deviceData.deviceExtendInfoKey4Labl}不能为空`,
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-input v-model="v.spareDeviceExtendInfoKey4"></el-input>
                    </el-form-item>
                    <!-- 备份设备扩展5 -->
                    <el-form-item
                      key="backupDeviceExtendInfoKey5"
                      v-if="deviceData.isDeviceExtendInfoKey5"
                      :label="deviceData.deviceExtendInfoKey5Labl"
                      :prop="`lstInfos.${i}.spareDeviceExtendInfoKey5`"
                      :rules="{
                        required: true,
                        message: `${deviceData.deviceExtendInfoKey5Labl}不能为空`,
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <el-input v-model="v.spareDeviceExtendInfoKey5"></el-input>
                    </el-form-item>
                  </template>
                </div>
                <el-form-item
                  key="canSplit"
                  v-if="deviceData.isCanSplit"
                  :error="v.activateQuantity > diffVal ? `当前可用总数为${deviceData.surplusQuantity}` : ''"
                  :show-message="v.activateQuantity > diffVal"
                  :rules="[{ pattern: /^[0-9]\d*$/, message: '请输入大于等于0的整数', trigger: ['blur', 'change'] }]"
                >
                  <template slot="label">
                    申请数量
                    <el-tooltip effect="dark" placement="top" :offset="-170">
                      <span slot="content" class="custom-tip">
                        1.表示需要和指定设备绑定的、当前授权码中包含的授权的数量。当设备因为更换网卡等硬件，需要重新激活授权时，请将该参数的值设置为0。<br />
                        2.临时授权码不支持拆分，申请数量无法修改。
                      </span>
                      <i class="el-icon-warning-outline"></i>
                    </el-tooltip>
                  </template>
                  <el-input
                    v-model.number="v.activateQuantity"
                    :readonly="deviceData.isSplitReadOnly"
                    style="width: 84px"
                    @input="handleNumBlur(v.activateQuantity, i)"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- <i
                class="el-icon-error"
                v-if="isShowSplit && !deviceData.isSplitReadOnly && Number(deviceData.surplusQuantity) > 1 && form.lstInfos.length > 1 && i !== 0"
                @click="handleDeviceDelete(i)"
              ></i> -->
              <img
                class="el-icon-error"
                src="@/assets/img/delete.svg"
                v-if="isShowSplit && !deviceData.isSplitReadOnly && Number(deviceData.surplusQuantity) > 1 && form.lstInfos.length > 1 && i !== 0"
                @click="handleDeviceDelete(i)"
              />
            </div>
            <el-button
              v-if="isShowSplit && !deviceData.isSplitReadOnly && Number(deviceData.surplusQuantity) > 1"
              type="text"
              icon="el-icon-circle-plus-outline"
              class="text-btn"
              @click="handleDevicePlus"
              >继续添加</el-button
            >
          </template>
        </el-form>
      </div>
      <div slot="footer" class="mt14" style="text-align: center">
        <el-button @click="handleClose">取 消</el-button>
        <el-button @click="handleResetDevice">重 置</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import deviceUploadFile from '@/components/deviceUploadFile';
import deviceOldUploadFile from '@/components/deviceOldUploadFile';
import requestActiveLicense from '@/request/requestActiveLicense';
import { mapGetters } from 'vuex';
export default {
  props: ['licenseKeys', 'itemIds', 'isBatch', 'checkList', 'deviceName'],
  components: {
    deviceUploadFile,
    deviceOldUploadFile,
  },
  data() {
    return {
      isShowDevice: false, // 是否显示弹窗
      dialogLoading: false, // 弹窗加载状态
      queryList: [],
      isContractSnReadonly: false, // 临时双机热备输入框是否可编辑
      categories: [], // 产品分类
      isSelected: null, // 是否自定义设备选中或者初始有值的状态
      NumberErrIndex: null,
      form: {
        codeModel: '', // 授权码绑定模式
        deviceUnit: this.deviceName,
        productCategoryID: null,
        extendMode_Radio: 0,
        didType: 'code',
        oldActivationFileName: null, // 历史激活文件名
        activationApplyFileName: null, // 服务器主机文件
        filePath: '', // 文件
        isCanSplit: false,
        lstInfos: [
          {
            activateQuantity: 0, // 授权码的在该设备上的激活规模数量
            contractSN: '', // 双机热备，服务合同单号
            deviceBackupType: '0', // 备份类型 0：无 2：双机热备 1：双机冷备
            deviceExtendInfoKey1: '', // 设备扩展1
            deviceExtendInfoKey2: '', // 设备扩展2
            deviceExtendInfoKey3: '', // 设备扩展3
            deviceExtendInfoKey4: '', // 设备扩展4
            deviceExtendInfoKey5: '', // 设备扩展5
            deviceOtherCode: '', // 设备唯一码（如需解析，为解析后设备唯一码）
            deviceOtherInfoFileName: '', // 设备文件名
            did: '', // 设备唯一码（用户输入）
            fileId: '', //
            filePath: '', // 设备信息的子文件路径
            h3CDeviceSN: '', // 设备SN
            id: 0, // 区分上传设备文件用
            productCategoryID: '', // 激活对应的产品分类
            spareDID: '', // 备机设备唯一码（用户输入）
            spareDeviceExtendInfoKey1: '', // 备设备扩展1
            spareDeviceExtendInfoKey2: '', // 备设备扩展2
            spareDeviceExtendInfoKey3: '', // 备设备扩展3
            spareDeviceExtendInfoKey4: '', // 备设备扩展4
            spareDeviceExtendInfoKey5: '', // 备设备扩展5
            spareDeviceOtherCode: '', // 备机设备唯一码（如需解析，为解析后设备唯一码）
            spareDeviceOtherInfoFileName: '', // 备份设备文件名
            spareFilePath: '', // 备份设备子文件路径
            spareH3CDeviceSN: '', // 备机设备SN
            tempHotActivation: false, // 申请临时双机热备激活码
            historical: false, // 是否为历史激活文件
            deviceFileErr: '', // 主设备文件上传错误信息
            spareDeviceFileErr: '', // 备份设备文件上传错误信息
          },
        ],
      },
      echoForm: {}, // 用于处理回显form
      deviceData: {
        extendMode_Radio: 0,
        deviceBackupTypeItem: false, // 备份类型
        isActivationApplyFile: false, // 文件类型
        deviceExtendInfoKey1Labl: '', // 扩展项1名称
        deviceExtendInfoKey2Labl: '', // 扩展项2名称
        deviceExtendInfoKey3Labl: '', // 扩展项3名称
        deviceExtendInfoKey4Labl: '', // 扩展项4名称
        deviceExtendInfoKey5Labl: '', // 扩展项5名称
        deviceUnit: '', // 设备标识
        didLabl: '', // 设备信息
        didType: 'code', // 设备信息类型
        extendModeRedio: '',
        isActivationApplyFIle: false, // 是否上传服务器主机文件
        isCanSplit: false, // 是否可拆分
        isConfirm: true, // 不确认产品分类及加载项时为  false:只展示did及设备附件
        isDID: false, // 是否需要输入设备唯一码
        isDevice: '', // 是否设备
        isDeviceBackupType: false, // 是否是双机
        isDeviceExtendInfoKey1: false, // 扩展项1是否展示
        isDeviceExtendInfoKey2: false, // 扩展项2是否展示
        isDeviceExtendInfoKey3: false, // 扩展项3是否展示
        isDeviceExtendInfoKey4: false, // 扩展项4是否展示
        isDeviceExtendInfoKey5: false, // 扩展项5是否展示
        isDeviceOtherInfoFile: false, // 是否需要上传设备信息文件
        isExtendModRadio: false, // 扩容选项，上传历史激活文件或服务器主机文件
        isH3CDeviceSN: false, // 是否需要输入设备SN
        isMainDeviceOtherInfoFile: false, // 是否需要上传主设备文件
        isProductCategory: false, // 是否展示产品分类
        isShowDID: true, // 是否显示设备唯一码
        isShowDeviceOtherInfoFile: true, // 是否显示设备文件
        isSplitReadOnly: false, // 支持拆分的授权码，如果类型为临时，不允许拆分使用
        isContractSN: false, // 双机热备，是否需要输入服务合同号
        isTempHotActivation: false, // 申请临时双机热备激活码
        licenseKey: '3132A0PF-qy6*vH@H-/3isfjbT-5qg2q7::', //
        productCategoryID: '',
        totelQuantity: '10', // 授权码生成时，原始规模数量，为0时，表示没有规模
        surplusQuantity: '8', // 当前可用的剩余规模数量
        lstInfos: [
          {
            activateQuantity: 0, // 授权码的在该设备上的激活规模数量
            contractSN: 'string', // 双机热备，服务合同单号
            deviceBackupType: '0', // 备份类型 0：无 2：双机热备 1：双机冷备
            deviceExtendInfoKey1: 'string', // 设备扩展1
            deviceExtendInfoKey2: 'string', // 设备扩展2
            deviceExtendInfoKey3: 'string', // 设备扩展3
            deviceExtendInfoKey4: 'string', // 设备扩展4
            deviceExtendInfoKey5: 'string', // 设备扩展5
            deviceOtherCode: 'string', // 设备唯一码（如需解析，为解析后设备唯一码）
            deviceOtherInfoFileName: 'string', // 设备文件名
            did: 'string', // 设备唯一码（用户输入）
            fileId: 'string', //
            filePath: 'string', // 设备信息的子文件路径
            fuzzyMatchingDID: 'string', // 根据Mac地址模糊配置到的设备唯一码
            fuzzyMatchingDeviceOtherCode: 'string', // 根据Mac地址模糊配置到的设备唯一码
            fuzzyMatchingFilePath: 'string', // 根据Mac地址模糊配置到的历史设备文件子路径
            fuzzyMatchingH3cDeviceSN: 'string', // 根据Mac地址模糊配置到的设备SN
            fuzzyMatchingParseDeviceOtherCode: 'string', // 根据Mac地址模糊配置到的设备信息重新生成的PID
            fuzzyMatchingParseSpareDeviceOtherCode: 'string', // 根据备机Mac地址模糊配置到的设备信息重新生成的PID
            fuzzyMatchingRequestId: 'string', // 模糊匹配到激活申请设备信息的主键id
            fuzzyMatchingSpareDID: 'string', // 根据Mac地址模糊配置到的备设备唯一码
            fuzzyMatchingSpareDeviceOtherCode: 'string', // 根据备机Mac地址模糊配置到的历史设备的设备唯一码
            fuzzyMatchingSpareFilePath: 'string', // 根据备机Mac地址模糊配置到的历史设备文件子路径
            fuzzyMatchingSpareH3CDeviceSN: 'string', // 根据备机Mac地址模糊配置到的历史设备SN
            fuzzyMatchingSpareRequestId: 'string', // 备机模糊匹配到激活申请设备信息的主键id
            h3CDeviceSN: 'string', // 设备SN
            id: 0, // 区分上传设备文件用
            productCategoryID: 'string', // 激活对应的产品分类
            spareDID: 'string', // 备机设备唯一码（用户输入）
            spareDeviceExtendInfoKey1: 'string', // 备设备扩展1
            spareDeviceExtendInfoKey2: 'string', // 备设备扩展2
            spareDeviceExtendInfoKey3: 'string', // 备设备扩展3
            spareDeviceExtendInfoKey4: 'string', // 备设备扩展4
            spareDeviceExtendInfoKey5: 'string', // 备设备扩展5
            spareDeviceOtherCode: 'string', // 备机设备唯一码（如需解析，为解析后设备唯一码）
            spareDeviceOtherInfoFileName: 'string', // 备份设备文件名
            spareFilePath: 'string', // 备份设备子文件路径
            spareH3CDeviceSN: 'string', // 备机设备SN
            tempHotActivation: false, // 申请临时双机热备激活码
          },
        ],
      },
      h3cSNRule: [
        { required: true, message: '不能为空', trigger: ['blur', 'change'] },
        {
          type: 'string',
          pattern: /^\s*[0-9a-zA-Z]+\s*$/g,
          message: '您输入的设备SN格式不正确，只允许输入数字或字母',
          trigger: ['blur', 'change'],
        },
      ],
      options: [
        { label: '仅绑定当前授权码', value: '1' },
        { label: '绑定当前授权码+历史激活文件', value: '2' },
        { label: '绑定当前授权码+服务器主机文件', value: '3' },
      ],
      productCategoryList: [], // 产品分类列表
      diffVal: 0,
      licenseInfoList: [], // 历史激活文件返回值
    };
  },
  computed: {
    ...mapGetters(['getQueryList']),
    // 处理双机热备radio显示
    backupTypes() {
      var typeItems = [];
      const types = this.deviceData.deviceBackupType_Item;
      for (const key in types) {
        typeItems.push({
          value: key,
          label: types[key],
        });
      }
      return typeItems;
    },
    // 判断继续添加按钮是否显示
    isShowSplit() {
      return this.deviceData.isCanSplit && this.deviceData.isConfirm;
    },
    // 判断拆分数量
    splitCount() {
      // 当前申请总数
      let splitCount = 0;
      for (const key of this.form.lstInfos) {
        splitCount += key.activateQuantity;
      }
      return splitCount;
    },
  },
  created() {
    this.getCheckDeviceInfo();
    this.form.deviceUnit = this.deviceName;
    this.form.deviceName = this.deviceName;
  },
  methods: {
    // 校验是否弹窗
    getCheckDeviceInfo(licenseKey) {
      this.deviceData = this.$options.data().deviceData;
      this.form.lstInfos = this.$options.data().form.lstInfos;
      let params = {
        cacheKey: this.$store.state.cacheKey,
        processId: this.$store.state.processId,
      };
      // 校验是否回填数据，如果licenseKey有，证明需要重新调取该
      if (licenseKey) {
        params.licenseKey = licenseKey;
      } else {
        // 需要校验是否为批量，批量用licenseKeyList，单个用licenseKey
        this.isBatch ? (params.licenseKeyList = this.licenseKeys) : (params.licenseKey = this.licenseKeys);
      }
      this.dialogLoading = true;
      requestActiveLicense
        .checkDeviceInfo(params)
        .then(res => {
          this.$emit('cancelLoading');
          if (res.res.code === 0) {
            this.deviceData = res.res.data;
            this.isShowDevice = res.res.isShowDevice; // 存入弹窗是否显示的值
            if (!this.isShowDevice) {
              this.$notify({
                title: '失败',
                message: res.res.message,
                type: 'error',
              });
              this.$emit('cancelDialog');
            }
            this.form.isCanSplit = this.deviceData.isCanSplit;
            this.form.didType = this.deviceData.didType;
            this.form.oldActivationFileName = this.deviceData.oldActivationFileName;
            this.form.extendMode_Radio = this.deviceData.extendMode_Radio ? Number(this.deviceData.extendMode_Radio) : 0;
            // 只有isProductCategory为true的情况下才允许有productCategoryID值
            this.form.productCategoryID =
              this.deviceData.isProductCategory && this.deviceData.productCategoryID ? this.deviceData.productCategoryID : '';
            this.form.isProductCategory = this.deviceData.isProductCategory;
            this.form.deviceUnit = this.form.deviceUnit ? this.form.deviceUnit : this.deviceData.deviceUnit ? this.deviceData.deviceUnit : '';
            this.form.lstInfos = JSON.parse(JSON.stringify(res.res.data.lstInfos));
            this.form.lstInfos.forEach(e => {
              e.deviceBackupType = String(e.deviceBackupType);
              e.tempHotActivation = e.tempHotActivation === 'false' ? false : true;
              e.deviceFileErr = ''; // 主设备文件上传错误信息
              e.spareDeviceFileErr = ''; // 备份设备文件上传错误信息
              // if (!this.deviceData.isDeviceBackupType) {
              //   e.spareDeviceOtherInfoFileName = null;
              //   e.deviceBackupType = '0';
              // }
              this.diffVal += e.activateQuantity ? e.activateQuantity : 0;
            });
          } else if (res.res.code === 9997) {
            this.$notify({
              title: '失败',
              message: res.res.message,
              type: 'error',
            });
            this.$emit('cancelDialog');
          } else {
            this.$emit('cancelDialog');
          }
          this.dialogLoading = false;
        })
        .catch(err => {
          this.$emit('cancelLoading');
          this.dialogLoading = false;
          this.$emit('cancelDialog');
        });
    },
    // 授权码绑定模式更改
    handleCodeModelChange(data) {
      // 切换绑定授权码的方式
      const deviceFileName = this.form.lstInfos[0].deviceOtherInfoFileName;
      this.form.extendMode_Radio = data;
      // 切换绑定授权码的方式为 绑定当前授权码+指定授权码 时，如果上传过设备信息文件，则自动填写到服务器主机文件输入框中
      if (deviceFileName && this.form.extendMode_Radio === 2) {
        this.isAssociateHostFile = true;
        this.form.activationApplyFileName = deviceFileName;
      }
    },
    // 自定义设备标识筛选
    querySearchAsync(queryString, cb) {
      const queryList = this.getQueryList;
      const results = queryString ? queryList.filter(this.createStateFilter(queryString)) : queryList;
      cb(results);
    },
    // 自定义设备标识字段过滤
    createStateFilter(queryString) {
      return state => {
        return state.deviceUnit.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    // 自定义标识匹配时
    handleDeviceSelect(data) {
      // 判断有没有产品分类
      if (this.deviceData.isProductCategory) {
        // 需要选择产品分类
        this.form.productCategoryID = data.productCategoryID;
      } else {
        this.form.productCategoryID = null;
      }
      // 判断拆分与否
      if (this.deviceData.isCanSplit) {
        if (data.isCanSplit) {
          // 支持拆分的情况,需要判断当前项数量和缓存数量，
          if (this.form.lstInfos.length > data.lstInfos.length) {
            // 当前项大于缓存项时，需要将缓存项填充到当前项
            data.lstInfos.forEach((e, i) => {
              for (let key in e) {
                this.form.lstInfos[i][key] = e[key];
              }
            });
          } else {
            // 当前项小于缓存项时，需要将缓存项替换到当前项
            this.form.lstInfos = data.lstInfos;
          }
        } else {
          // 不支持拆分的情况
          // this.$set(this.form.lstInfos, 0, data.lstInfos[0]);
          this.form.lstInfos.forEach((e, i) => {
            for (let key in e) {
              this.form.lstInfos[i][key] = data.lstInfos[i][key];
            }
          });
        }
        // 判断是否支持双机热备，支持的话进行赋值
        this.form.deviceBackupType = data.deviceBackupType ? data.deviceBackupType : 0;
        this.form.lstInfos.forEach((e, i) => {
          for (let key in e) {
            this.form.lstInfos[i][key] = data.lstInfos[i][key];
            if (!this.deviceData.isDeviceBackupType) {
              this.form.lstInfos[i]['deviceBackupType'] = '0';
            }
          }
        });
      } else {
        for (let key in this.form.lstInfos[0]) {
          this.form.lstInfos[0][key] = data.lstInfos[0][key];
          if (!this.deviceData.isCanSplit) {
            this.form.lstInfos[0]['activateQuantity'] = 0;
          }
          if (!this.deviceData.isDeviceBackupType) {
            this.form.lstInfos[0]['deviceBackupType'] = '0';
          }
        }
      }
      // 判断是否支持双机热备，支持的话进行赋值
      if (this.deviceData.isDeviceBackupType) {
        this.form.deviceBackupType = data.deviceBackupType ? data.deviceBackupType : 0;
      }
      // 判断是否支持扩容
      if (this.deviceData.isExtendModRadio) {
        this.form.extendedModeRadio = data.extendedModeRadio ? data.extendedModeRadio : '0';
      }
      this.form.deviceName = data.deviceName;
      this.form.deviceUnit = data.deviceUnit;
      this.form.didType = data.didType ? data.didType : 'code';
      this.form.productCategoryID = '';
      // this.form.productCategoryID = data.productCategoryID ? data.productCategoryID : '';
      let ids = this.form.lstInfos.map(v => v.id);
      // 调取文件复制
      this.uploadFileRequestFn(ids);
    },
    // did码和文件类型切换时
    handleDidTypeChange(type) {
      if (type === 'code') {
        this.form.lstInfos[0].deviceOtherInfoFileName = '';
      } else {
        this.form.lstInfos[0].did = null;
      }
    },
    // 双机热备切换
    handleDeviceRadioChange(v) {
      // 清空备份设备已经上传过得文件及地址
      v.spareDeviceOtherInfoFileName = null;
      v.spareFilePath = null;
      v.contractSN = null;
      v.tempHotActivation = false;
    },
    // 临时双机热备激活码check
    handleDoubleCheckChange(v) {
      if (v.tempHotActivation) {
        v.contractSN = '00000000000000';
        this.isContractSnReadonly = true;
      } else {
        v.contractSN = '';
        this.isContractSnReadonly = false;
      }
    },
    // 主设备/不确定设备DID上传文件回调
    uploadCallbackFn(val, i, isMaster) {
      this.form.lstInfos[i].deviceOtherInfoFileName = val;
      this.form.lstInfos[i].isMaster = isMaster;
      // this.form.deviceUnit = this.form.deviceUnit ? this.form.deviceUnit : val;
      // if (this.spareDeviceOtherInfoFileName) {
      //   this.model.deviceList[0].spareDeviceOtherInfoFileName = this.spareDeviceOtherInfoFileName;
      // }
    },
    // 备份设备上传文件回调
    spareUploadCallbackFn(val, i, isMaster) {
      this.form.lstInfos[i].spareDeviceOtherInfoFileName = val;
      this.form.lstInfos[i].isMaster = isMaster;
    },
    // 设备信息文件删除
    deviceFileClearFn(val, i, isMaster) {
      if (isMaster) {
        this.form.lstInfos[i].deviceOtherInfoFileName = val;
      } else {
        this.form.lstInfos[i].spareDeviceOtherInfoFileName = val;
      }
      this.dialogLoading = true;
      requestActiveLicense
        .cancelDeviceFile({
          cacheKey: this.$store.state.cacheKey,
          deviceID: i,
          isMaster: isMaster,
          licenseKeyList: this.isBatch ? this.licenseKeys : [this.licenseKeys],
        })
        .then(res => {
          if (res.code === '0') {
            this.$notify({
              title: '成功',
              message: res.res.message,
              type: 'success',
            });
          }
          this.dialogLoading = false;
        })
        .catch(err => {
          this.dialogLoading = false;
        });
    },
    // 历史文件上传回调
    uploadOldCallBackFn(val) {
      this.licenseInfoList = val;
      this.getCheckDeviceInfo();
    },
    // 查询授权信息列表
    getSelAuthorizeList() {
      let licenseKeyList = this.licenseInfoList.map(e => {
        return e.licenseKey;
      });
      return requestActiveLicense.selAuthorizeList({
        isOld: '1',
        licenseKeyList: licenseKeyList,
        processId: this.$store.state.processId,
      });
    },
    // 设备拆分增加
    handleDevicePlus() {
      const data = {
        id: this.form.lstInfos.length,
        activateQuantity: 0,
        activationApplyFilePath: null,
        contractSN: null,
        deviceBackupType: '0',
        deviceExtendInfoKey1: null,
        deviceExtendInfoKey2: null,
        deviceExtendInfoKey3: null,
        deviceExtendInfoKey4: null,
        deviceExtendInfoKey5: null,
        deviceOtherInfoFileName: '',
        did: null,
        h3CDeviceSN: null,
        spareDID: null,
        spareDeviceExtendInfoKey1: null,
        spareDeviceExtendInfoKey2: null,
        spareDeviceExtendInfoKey3: null,
        spareDeviceExtendInfoKey4: null,
        spareDeviceExtendInfoKey5: null,
        spareDeviceOtherInfoFileName: '',
        spareH3CDeviceSN: null,
        tempHotActivation: false,
        historical: false, // 是否为历史激活文件
        deviceFileErr: '', // 主设备文件上传错误信息
        spareDeviceFileErr: '', // 备份设备文件上传错误信息
      };
      if (this.splitCount < Number(this.deviceData.surplusQuantity)) {
        this.form.lstInfos.push(data);
      } else {
        this.$notify({
          title: '失败',
          message: '超过可添加总数',
          type: 'error',
        });
      }
    },
    // 设备拆分删除
    handleDeviceDelete(i) {
      this.form.lstInfos.splice(i, 1);
    },
    // 历史文件删除
    oldDeviceFileClearFn() {
      this.form.oldActivationFileName = '';
    },
    // 申请数量变化校验
    handleNumBlur(e, i) {
      let newArr = [...this.form.lstInfos];
      newArr.splice(i, 1);
      let countNum = newArr.reduce((total, num) => {
        return total + Number(num.activateQuantity);
      }, 0);
      this.diffVal = Number(this.deviceData.surplusQuantity) - countNum >= 0 ? Number(this.deviceData.surplusQuantity) - countNum : 0;
      if (!e) {
        this.$set(this.form.lstInfos[i], 'activateQuantity', 0);
      }
      // 赋值，暂时不用
      // else {
      // if (e > this.diffVal) {
      // this.$set(this.form.lstInfos[i], 'activateQuantity', this.diffVal);
      // }
      // }
    },
    // 确认提交
    submitForm(formName) {
      // 清空文件上传错误信息提示
      this.form.lstInfos.forEach((v, i) => {
        this.$set(this.form.lstInfos[i], 'deviceFileErr', '');
        this.$set(this.form.lstInfos[i], 'spareDeviceFileErr', '');
      });
      if (this.splitCount > Number(this.deviceData.surplusQuantity)) {
        this.$notify({
          title: '失败',
          message: '超过可添加总数',
          type: 'error',
        });
        return;
      }
      this.form.deviceUnit = this.form.deviceUnit ? this.form.deviceUnit : this.form.lstInfos[0].deviceOtherInfoFileName;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.inputDeviceInfoFn();
        } else {
          return false;
        }
      });
    },
    // 提交设备信息
    inputDeviceInfoFn() {
      this.dialogLoading = true;
      let params = {
        cacheKey: this.$store.state.cacheKey,
        processId: this.$store.state.processId,
        productCategoryId: this.form.productCategoryID,
        deviceName: this.form.deviceUnit,
        deviceUnit: this.form.deviceUnit,
        didType: this.form.didType,
        extendMode_Radio: this.form.extendMode_Radio,
        lstInfos: this.form.lstInfos,
      };
      // 需要校验是否为批量，批量用licenseKeyList，单个用licenseKey
      this.isBatch ? (params.licenseKeyList = this.licenseKeys) : (params.licenseKey = this.licenseKeys);
      this.form.extendMode_Radio === 1 ? (params.licenseKeyInfoList = this.licenseInfoList) : '';
      requestActiveLicense
        .inputDeviceInfo(params)
        .then(res => {
          if (res.res.code === 0) {
            let data = res.res.data;
            // 存入自定义标识下拉选项
            if (res.res.isShowDevice && data.isProductCategory) {
              this.deviceData.isProductCategory = data.isProductCategory;
              this.productCategoryList = data.lstProCategoryForSelect;
              this.form.lstInfos = data.lstInfos;
            } else if (res.res.isShowDevice) {
              this.deviceData = data;
              this.form.didType = data.didType;
              this.form.lstInfos = data.lstInfos;
            } else if (this.form.extendMode_Radio === 1) {
              // 获取历史文件查询设备
              this.getSelAuthorizeList()
                .then(res => {
                  if (res.code === '0') {
                    this.$emit('cancelDialog');
                    this.$emit('callBackData', this.form.deviceUnit, res.res, this.itemIds);
                  }
                })
                .catch(err => {
                  this.$emit('cancelDialog');
                  this.$emit('callBackData', '', [], []);
                });
            } else {
              this.$store.dispatch('updateDeviceQueryFn', Object.assign({}, this.form));
              this.$notify({
                title: '成功',
                message: '提交成功',
                type: 'success',
              });
              // 关闭弹窗
              this.$emit('cancelDialog');
              // 给列表反数据
              this.$emit('callBackData', this.form.deviceUnit, [], this.itemIds);
            }
          } else if (res.res.code === 9997) {
            let data = res.res.message.split('\\n');
            let errDom = '';
            data.forEach(e => {
              errDom += `<p style="margin-bottom: 5px;">${e}</p>`;
            });
            this.$alert(`<div style="min-width: 450px;max-height: 300px; overflow-y: auto;">${errDom}</div>`, '提示', {
              dangerouslyUseHTMLString: true,
              customClass: 'alertClass submit-err',
            });
          } else if (res.res.code === 9998) {
            let data = res.res.data;
            let _this = this;
            let errDom = '';
            data.forEach((e, i) => {
              errDom += `<p>设备${e.id + 1} ${_this.form.lstInfos[e.id].deviceBackupType === '0' ? '' : e.isMaster ? '【主设备】' : '【备份设备】'} ${
                e.message
              }</p>`;
              _this.$set(_this.form.lstInfos[e.id], `${e.isMaster ? 'deviceFileErr' : 'spareDeviceFileErr'}`, e.message);
            });
            this.$notify({
              title: '失败',
              dangerouslyUseHTMLString: true,
              message: `${errDom}`,
              type: 'error',
            });
          }
          this.dialogLoading = false;
        })
        .catch(err => {
          this.dialogLoading = false;
        });
    },
    // 批量触发上传文件函数
    uploadFileRequestFn(ids) {
      // 过滤多选和单选，处理licenseKey不同展示方式,多选取第一个，单选不做处理
      let licenseKey = this.isBatch ? this.licenseKeys[0] : this.licenseKeys;
      let params = {
        licenseKey: licenseKey,
        ids: ids,
        deviceUnit: this.form.deviceUnit,
        cacheKey: this.$store.state.cacheKey,
      };
      this.dialogLoading = true;
      requestActiveLicense
        .copyDeviceFile(params)
        .then(res => {
          if (res.code === '0') {
            let data = res.res.data;
            this.form.lstInfos.forEach((v, i) => {
              if (v.id === data[i].id) {
                v.deviceOtherInfoFileName = data[i].deviceFileName;
                v.spareDeviceOtherInfoFileName = data[i].spareDeviceFileName;
              }
            });
          }
          this.dialogLoading = false;
        })
        .catch(err => {
          this.dialogLoading = false;
        });
    },

    // 弹窗关闭
    handleClose() {
      this.$emit('cancelDialog');
    },
    // 重置
    handleResetDevice() {
      this.dialogLoading = true;
      requestActiveLicense
        .resetApi({
          cacheKey: this.$store.state.cacheKey,
          // deviceID: 0,
          processId: this.$store.state.processId,
          licenseKeyList: this.isBatch ? this.licenseKeys : [this.licenseKeys],
        })
        .then(res => {
          if (res.code === '0') {
            this.$notify({
              title: '成功',
              message: res.res.message,
              type: 'success',
            });
            this.form.deviceUnit = null;
            this.form.deviceName = null;
            // 给列表反数据
            this.$emit('callBackData', '', [], this.itemIds);
            this.getCheckDeviceInfo();
          }
          this.dialogLoading = false;
        })
        .catch(err => {
          this.dialogLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-title {
  font-size: 14px !important;
  color: #333;
  font-weight: 600;
  margin-left: 11px;
}

.dialog-code {
  /deep/ .el-dialog__body {
    padding: 20px 0;
  }
  /deep/ .el-dialog__footer {
    text-align: center;
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    background: #fff !important;
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner::after {
    background-color: @currentColor !important;
    width: 6px;
    height: 6px;
  }

  .text-btn {
    color: @currentColor;
    font-weight: 400;
  }
  .form-item-wrap {
    background-color: #f4f6fa;
    margin-bottom: 12px;
    position: relative;
    padding: 14px 0;
    box-sizing: border-box;
  }
  .form-item-wrap::after,
  .form-item-wrap::before {
    content: '';
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  .form-item-wrap:last-child {
    margin-bottom: 0 !important;
  }
  h4 {
    margin: 0;
    margin-bottom: 14px;
    color: #333 !important;
  }
  .el-icon-error {
    position: absolute;
    top: -5px;
    right: -5px;
    cursor: pointer;
  }
}
.dialog-item-wrap {
  max-height: 562px;
  padding: 0 32px;
  box-sizing: border-box;
  overflow-y: auto;
}
.custom-tip {
  display: block;
  width: 360px;
}
.custom-input {
  width: 200px;
}
.device-out-file {
  width: 238px;
  margin-right: 10px;
}
.device-file-input {
  width: 190px;
  margin-right: 10px;
}
.split-lint {
  border-top: 1px solid #e6e8ec;
}
.split-bottom-line {
  border-bottom: 1px solid #e6e8ec;
  margin-bottom: 14px;
}
.split-padding {
  padding: 0px 24px;
  box-sizing: border-box;
}
.mb14 {
  margin-bottom: 14px;
}
.mt14 {
  margin-top: 14px;
}
.mt10 {
  margin-top: 10px;
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
</style>
<style lang="less">
.submit-err {
  width: auto !important;
}
</style>
